import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Landmark, AlertTriangle } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { status, user, memberships, refresh, lastError } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    // Si un ``lastError`` réseau/serveur est présent, on affiche un état
    // d'erreur avec bouton Réessayer plutôt qu'un loader infini.
    if (lastError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6 text-center">
          <AlertTriangle className="h-10 w-10 text-amber-500" />
          <h1 className="mt-4 font-serif text-2xl">Connexion au service momentanément impossible</h1>
          <p className="mt-2 max-w-md text-sm text-muted-foreground" data-testid="auth-boot-error-message">
            {lastError.message}
          </p>
          <button
            type="button"
            onClick={refresh}
            data-testid="auth-boot-retry-btn"
            className="mt-6 rounded-full bg-primary px-5 py-2 text-sm text-primary-foreground hover:bg-primary/90"
          >
            Réessayer
          </button>
        </div>
      );
    }
    return (
      <div className="flex min-h-screen items-center justify-center bg-background"
           data-testid="auth-boot-loader">
        <div className="flex items-center gap-3 text-muted-foreground">
          <Landmark className="h-5 w-5 animate-pulse text-primary" />
          <span className="font-heading text-sm">Chargement de votre espace…</span>
        </div>
      </div>
    );
  }
  if (status === "guest") {
    return <Navigate to="/login" state={{ from: location, sessionExpired: true }} replace />;
  }
  // Pure super admin (no client memberships) → redirect to /admin
  const role = user?.platform_role;
  const hasMemberships = (memberships || []).length > 0;
  if (role === "platform_admin" && !hasMemberships) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
